/**
 *
 * @component 项目管理/协作项目详情/施工进度计划tab/选择模板弹窗
 *
 **/

import React, { memo } from 'react';
import {
    Button,
    Space,
    Empty,
    Table,
    Form,
    DatePicker,
    message,
    Spin,
    Drawer,
    Radio,
    List,
    Tooltip,
} from 'antd';
import BaseModal from '&/components/BaseModal';
import {
    queryTemplates,
    deleteTemplate,
    saveTemplate,
} from '@/api/personCenter/projectSpace1.4';
import { DeleteOutlined } from '@ant-design/icons';
import { deleteModal } from '&/components/TemplateManagement/common';
import './SelectTemplate.scss';

function SelectTemplate(props) {
    const { visible, setVisible, createPlan, projectId, refresh } = props;
    const closeModal = () => {
        setVisible(false);
        cleanModalData();
    };

    const emptyProps = {
        width: '31.25rem',
        children: (
            <Empty
                image={
                    require('@/assets/img/userCenter1.4/emptyydata-object.png')
                        .default
                }
                imageStyle={{
                    height: '11rem',
                }}
                description={
                    <>
                        <div className="empty-title">
                            {intl.get('templateSettings.emptyTemplate')}
                        </div>
                        <div className="message">
                            {intl.get('templateSettings.saveMethond')}
                        </div>
                        <Space size={20} className="buy-link">
                            <div onClick={createPlan}>
                                {intl.get('projectSpace.newPlan')}
                            </div>
                        </Space>
                    </>
                }></Empty>
        ),
    };

    function removeTemplate(current) {
        deleteModal(
            async () => {
                const { msg } = await deleteTemplate({
                    templateId: [current.id],
                });
                getList();
                message.success(msg);
                cleanSelectStatus();
            },
            {
                content: intl.get('templateSettings.templateDeleteWarning'),
            }
        );
    }

    const columns = [
        {
            title: intl.get('projectSpace.constructionProcess'),
            dataIndex: 'constructionProcess',
            width: '30%',
        },

        {
            title: intl.get('templateSettings.constructionItem'),
            dataIndex: 'constructionItem',
            width: '30%',
        },
        {
            dataIndex: 'timeLimit',
            title: intl.get('projectSpace.planLimit'),
            align: 'center',
        },
    ];

    const [queryForm, setQueryForm] = useState({
        page: 1,
        pageNum: 10,
    });

    const handlePageChange = page => {
        setQueryForm(state => ({ ...state, page }));
    };

    const [result, setResult] = useState({
        list: [],
        count: 0,
    });
    const [isLoading, setIsLoading] = useState(false);
    const [expandIndex, setExpandIndex] = useState(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectTemp, setSelectTemp] = useState(null);
    const [selectBtnStatus, setSelectBtnStatus] = useState(true);

    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        checkStrictly: false,
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);
        },
    };

    useEffect(() => {
        visible && getList();
    }, [queryForm, visible]);
    useEffect(() => {
        cleanSelectStatus();
    }, [queryForm]);
    useEffect(() => {
        if (selectTemp) {
            if (selectTemp.isDefaultTemp) {
                if (selectedRowKeys.length) {
                    setSelectBtnStatus(false);
                } else {
                    setSelectBtnStatus(true);
                }
            } else {
                setSelectBtnStatus(false);
            }
        } else {
            setSelectBtnStatus(true);
        }
    }, [selectTemp, selectedRowKeys]);

    const cleanSelectStatus = () => {
        setExpandIndex(null);
        setSelectedRowKeys([]);
        setSelectTemp(null);
    };

    function getList() {
        setIsLoading(true);
        queryTemplates({ projectId, ...queryForm })
            .then(({ data }) => {
                data.list = data.list.map(item => {
                    const tableData = Object.keys(item.son).map(key => {
                        let timeLimit = 0;
                        const sonItem = item.son[key];
                        const children = sonItem.flow.map(flowItem => {
                            timeLimit += parseFloat(flowItem.timeLimit);
                            return {
                                ...flowItem,
                                constructionItem: flowItem.name,
                                key: flowItem.id,
                            };
                        });
                        const processName =
                            key === intl.get('templateSettings.notDef')
                                ? intl.get('templateSettings.notClassified')
                                : key;
                        return {
                            timeLimit,
                            constructionProcess: processName,
                            key: `f-${sonItem.planFlowId}`,
                            children,
                        };
                    });
                    return {
                        ...item,
                        templateName: item.name,
                        templateTime: `${intl.get(
                            'templateSettings.timesLabel'
                        )}${item.allTimeLimit}`,
                        mark: `${intl.get('templateSettings.remarkLabel')}${
                            item.remark || ''
                        }`,
                        isDefaultTemp: item.dap === '1',
                        tableData,
                    };
                });
                setResult(data);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    function cleanModalData() {
        setQueryForm({ page: 1, pageNum: 10 });
        cleanSelectStatus();
    }
    const expand = (item, index) => {
        if (expandIndex !== index) {
            setExpandIndex(index);
            setSelectTemp(item);
        } else {
            setExpandIndex(null);
            setSelectTemp(null);
        }
        setSelectedRowKeys([]);
    };

    const templateProps = {
        width: '50rem',
        children: (
            <>
                <List
                    className="template-list-box"
                    bordered
                    dataSource={result.list}
                    pagination={{
                        size: 'small',
                        current: queryForm.page,
                        onChange: handlePageChange,
                        defaultPageSize: queryForm.pageNum,
                        total: result.count,
                        showSizeChanger: false,
                        style: {
                            marginBottom: 0,
                        },
                        showTotal: total => intl.get('base.total', { total }),
                    }}
                    renderItem={(item, index) => {
                        return (
                            <div className="list-item-box" key={index}>
                                <div
                                    onClick={() => {
                                        expand(item, index);
                                    }}
                                    className={[
                                        'list-item-header-box',
                                        expandIndex === index
                                            ? 'activeBox'
                                            : '',
                                    ].join(' ')}>
                                    <div className="template-name-box">
                                        {expandIndex === index ? (
                                            <i className="icon-caret-down filled pointer" />
                                        ) : (
                                            <i className="icon-caret-right filled pointer" />
                                        )}
                                        <Tooltip title={item.templateName}>
                                            <span>{item.templateName}</span>
                                        </Tooltip>
                                    </div>
                                    <p className="template-time">
                                        {item.templateTime}
                                    </p>
                                    <p className="template-mark">
                                        <Tooltip title={item.mark}>
                                            <span>{item.mark}</span>
                                        </Tooltip>
                                    </p>
                                    <span className="template-btn">
                                        {!item.isDefaultTemp && (
                                            <DeleteOutlined
                                                className="remove-icon"
                                                onClick={e => {
                                                    e.stopPropagation();
                                                    removeTemplate(item);
                                                }}
                                            />
                                        )}
                                    </span>
                                </div>
                                <div className="list-item-content-box">
                                    {expandIndex === index && (
                                        <Table
                                            bordered
                                            rowSelection={
                                                item.isDefaultTemp
                                                    ? rowSelection
                                                    : false
                                            }
                                            pagination={false}
                                            className="budget-privew"
                                            size="small"
                                            columns={columns}
                                            rowKey="key"
                                            dataSource={item.tableData}
                                        />
                                    )}
                                </div>
                            </div>
                        );
                    }}
                />
            </>
        ),
    };

    const [dateVisible, setDateVisible] = useState();
    const [addType, setAddType] = useState(1); // 1追加 2覆盖

    function closeAll() {
        setDateVisible(false);
        closeModal();
    }
    const handleConfirm = () => {
        /*if (!selectedRowKeys.length) {
            return message.warning('请先勾选模板');
        }*/
        setDateVisible(true);
    };
    const changeAddType = e => [setAddType(e.target.value)];

    const [btnLoading, setBtnLoading] = useState(false);

    const day = useRef('');
    function onDateChange(date, dateString) {
        day.current = dateString;
    }

    // 提交使用模板
    function applyTemplates() {
        if (!day.current) {
            message.warning(intl.get('templateSettings.selectStart'));
            return;
        }

        const { templateName, isDefaultTemp, tableData } = selectTemp;
        let templateId = [];
        if (!isDefaultTemp) {
            tableData.forEach(item => {
                item.children.forEach(sonItem => {
                    templateId.push(sonItem.id);
                });
            });
        } else {
            templateId = selectedRowKeys.filter(
                item => item.indexOf('f-') === -1
            );
        }
        const PARAMS = {
            projectId,
            type: addType,
            dop: 2,
            templateName,
            templateId,
            day: day.current,
        };
        setBtnLoading(true);
        saveTemplate(PARAMS)
            .then(() => {
                refresh();
                closeAll();
            })
            .finally(() => {
                setBtnLoading(false);
            });
    }

    return (
        <>
            <Drawer
                className="select-template-drawer"
                title={intl.get('projectSpace.selectTemplate')}
                footer={
                    result.count > 0 && (
                        <Space>
                            <Radio.Group
                                name="radiogroup"
                                value={addType}
                                onChange={changeAddType}>
                                <Radio value={1}>
                                    {intl.get('templateSettings.superaddition')}
                                </Radio>
                                <Radio value={2}>
                                    {intl.get('templateSettings.cover')}
                                </Radio>
                            </Radio.Group>
                            <Button onClick={closeModal}>
                                {intl.get('base.cancel')}
                            </Button>
                            <Button
                                type="primary"
                                disabled={selectBtnStatus}
                                onClick={handleConfirm}>
                                {intl.get('base.confirm')}
                            </Button>
                        </Space>
                    )
                }
                footerStyle={{ display: 'flex', justifyContent: 'flex-end' }}
                // closable={true}
                visible={visible}
                autoFocus
                onClose={closeAll}
                width={
                    result.count > 0 ? templateProps.width : emptyProps.width
                }
                extra={
                    <Space>
                        <i
                            onClick={closeAll}
                            className="drawer-header-icon icon-close filled"
                        />
                    </Space>
                }>
                <div
                    className={`${
                        result.count > 0
                            ? 'select-template'
                            : 'select-template is--empty'
                    }`}>
                    <Spin spinning={isLoading}>
                        {result.count > 0
                            ? templateProps.children
                            : emptyProps.children}
                    </Spin>
                </div>
            </Drawer>

            <BaseModal
                getContainer=""
                title={intl.get('templateSettings.setStart')}
                visible={dateVisible}
                onCancel={setDateVisible.bind(null, false)}
                footer={
                    <Space>
                        <Button onClick={setDateVisible.bind(null, false)}>
                            {intl.get('base.cancel')}
                        </Button>
                        <Button
                            loading={btnLoading}
                            type="primary"
                            onClick={applyTemplates}>
                            {intl.get('base.confirm')}
                        </Button>
                    </Space>
                }
                width="25.75rem">
                <div className="select-template">
                    <Form.Item
                        required
                        label={intl.get('projectSpace.planStart')}>
                        <DatePicker
                            style={{ width: '100%' }}
                            onChange={onDateChange}
                            suffixIcon={<i className="icon-calendar filled" />}
                        />
                    </Form.Item>
                </div>
            </BaseModal>
        </>
    );
}

export default memo(SelectTemplate);
